import styled from '@emotion/styled'
import Typography from '@mui/material/Typography'
import { parseISO, format } from 'date-fns'
import { ExternalLink, theme } from 'j-comps'
import { formatBytes } from '../../../../../../../../utils'
import config from '../../../../../../../../config'

const Container = styled.div`
  text-align: left;
  padding: 10px;
`

const Stat = styled.div`
  display: flex;
`

const StatLabel = styled.p`
  margin: 0;
  margin-right: ${theme.spacing.medium};
  font-weight: ${theme.font.weight.bold};
  color: ${theme.color[config.app].primary};
`

const StatText = styled.p`
  margin: 0;
  color: black;
`

const MetaData = ({ design }) => {
  return (
    <Container>
      <Typography color={'inherit'}>Metadata</Typography>
      <hr />
      <Stat>
        <StatLabel>URL:</StatLabel>
        <StatText>
          <ExternalLink href={design.url}>{design.url}</ExternalLink>
        </StatText>
      </Stat>
      <Stat>
        <StatLabel>SIZE:</StatLabel>
        <StatText>{formatBytes(design.size)}</StatText>
      </Stat>
      <Stat>
        <StatLabel>LAST MODIFIED:</StatLabel>
        <StatText>
          {format(parseISO(design.lastModified), 'MMM d, yyyy h:m:s a')}
        </StatText>
      </Stat>
    </Container>
  )
}

export default MetaData
